import "./App.css";
import { ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import Routing from "./Routing";
import Theme from "./Theme/Theme";
import HelmetMetaData from "./Components/HelmetMetaData";
import { GlobalThemeProvider } from "./Components/Context/TimerContext";
import { NotificationProvider } from "./Contexts/notification-context/NotificationProvider";
import BranchProvider from "./Contexts/branch-context/BranchProvider";
import DelayPickingOrderProvider from "./Contexts/order-context/DelayPickingOrderProvider";

function App() {
  return (
    <GlobalThemeProvider>
      <HelmetMetaData />
      <ThemeProvider theme={Theme}>
        <DelayPickingOrderProvider>
          <BranchProvider>
            <NotificationProvider>
              <BrowserRouter>
                <Routing />
              </BrowserRouter>
            </NotificationProvider>
          </BranchProvider>
        </DelayPickingOrderProvider>
      </ThemeProvider>
    </GlobalThemeProvider>
  );
}

export default App;
